import { Template } from "./template.js";


const Left_menu = {
	data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			curr_tube: null,
			fields: [{
				key: 'wire',
				label: '',
			}, {
				key: 'tubeData.tube_name',
				label: this.$t('tubes.tube'),
				sortable: true
			}, 
			// {
			// 	key: 'tubeData.battery',
			// 	label: '🔋, %',
			// 	sortable: true
			// },

			{
				key: 'isol',
				label: '',
			},
				{
					key: 'tubeData.isol',
					label: 'Ω',
					sortable: true
				},],

		}
	},
	computed: {
		menuRows() {
			return this.tubes.length
		}
	},
	updated() {
		this.fields[1].label = this.$t('tubes.tube');
	},
	props: {
		tubes: Array
	},
	methods: {
		rowClass(item, type) {
			// console.log('rowClass', item);
			if (!item || type !== 'row') 
				return;
			if (item.tubeData.tube_name == this.curr_tube) 
				return 'left-menu-table_active';
		},
		isolStyle(item) {
			return {
				'background-color': this.$getColorTemp(item.tubeData.isol),
				'width': (90 * item.tubeData.isol / 100 + 10) + '%'
			}
		},
		tubeListClick(record, index) {
			// 'record' will be the row data from items
			// `index` will be the visible row number (available in the v-model 'shownItems')
			// console.log('aaa',record); // This will be the item data for the row
			this.curr_tube = record.tubeData.tube_name;
			this.rowClass();
			this.$emit("line-click", record);
		},
		wireIcons(item) {
			let icons = '';
			icons += (item.tubeData.wire == '0' ? '⚡︎' : '');
			icons += (item.tubeData.isol == '0' ? '🚫' : '');
			icons += (item.tubeData.too_old ? '⏰' : '');
			//TODO: check if this is really "alarm*" and s_alarm = 0, tet on real devices
			//TODO: "alarm1" should show icons only on modem "_A", "alarm2" -> "_B"
			// icons += (item.tubeData.reason.includes("alarm")&&(item.tubeData.s_alarm == '0') ? '💦' : '');
			icons +=(item.tubeData.s_alarm == '0' ? (item.tubeData.reason.includes("alarm") ? '💦' : '💧') : '');
			//		if (icons == '') icons = '✅';
			return icons;

		},
		filterTable(row, filter) {
			this.currentPage = 1;
			return !!row.tubeData.tube_name.toLowerCase().includes(filter.toLowerCase());
		}

	},
	template: Template
}

export { Left_menu }


// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/left_menu/component.js